import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/MouseWithin/MouseWithinUsage.mdx";

import Examples from "../../Docs/Components/MouseWithin/MouseWithinExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="MouseWithin"
            description="Utility used to determine if the mouse pointer is currently inside the given set of elements."
            apiSources={["azure-devops-ui/Components/MouseWithin/MouseWithin.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;